<template>
  <div class="logistic">
    <!--设置查看-->
    <Modal v-model="ymsLogisticsChannelModal" :title="logisticsChannelTitle" width="1200" :styles="{top: '40px'}"
      :class-name="'logistic-modal'" :transfer="false" :mask-closable="false" @on-visible-change="ymsLogisticsChannelModalChange">
      <!--渠道基础信息-->
      <Card :bordered="true" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1002350') }}</h2>
        </template>
        <Form :label-width="labelWidth" ref="ymsLogisticsChannelModalParams" :model="ymsLogisticsChannelModalParams" @submit.native.prevent>
          <Row type="flex">
            <Col :span="14">
              <FormItem :label="$t('key1004010')" prop="logisticsChannelsName" class="required_style_label">
                <span v-if="openType === 'look'">{{ ymsLogisticsChannelModalParams.logisticsChannelsName }}</span>
                <Input v-else v-model.trim="ymsLogisticsChannelModalParams.logisticsChannelsName" disabled/>
              </FormItem>
            </Col>
            <Col :span="11">
              <FormItem :label="$t('key1005296')">
                <div v-if="openType === 'look'">
                  <span>{{ ymsLogisticsChannelModalParams.minEfficiency }}</span>
                  <span> - </span>
                  <span>{{ ymsLogisticsChannelModalParams.maxEfficiency }}</span>
                  <span class="font-size-12 ml2">{{ $t('key1001631') }}</span>
                </div>
                <div v-else>
                  <InputNumber class="w100" :min="0" :max="999" @on-blur="blurChange" v-model="ymsLogisticsChannelModalParams.minEfficiency"/>
                  -
                  <InputNumber :min="0" :max="999" class="w100" @on-blur="blurChange" v-model="ymsLogisticsChannelModalParams.maxEfficiency"/>
                  <span class="font-size-12 ml4">{{ $t('key1000411') }}</span>
                </div>
              </FormItem>
            </Col>
            <Col :span="11">
              <FormItem :label="$t('key1005298')">
                <div v-if="openType === 'look'" class="flex align-items-center">
                  <span>{{ ymsLogisticsChannelModalParams.maxLength }}</span>
                  <span class="mr4 ml4">*</span>
                  <span>{{ ymsLogisticsChannelModalParams.maxWidth }}</span>
                  <span class="mr4 ml4">*</span>
                  <span> {{ ymsLogisticsChannelModalParams.maxHeight }} </span>
                </div>
                <div v-else class="flex align-items-center">
                  <InputNumber :min="0" :max="999999" @on-blur="blurChange" v-model="ymsLogisticsChannelModalParams.maxLength"></InputNumber>
                  <span class="mr4 ml4">*</span>
                  <InputNumber :min="0" :max="999999" @on-blur="blurChange" v-model="ymsLogisticsChannelModalParams.maxWidth"></InputNumber>
                  <span class="mr4 ml4">*</span>
                  <InputNumber :min="0" :max="999999" @on-blur="blurChange" v-model="ymsLogisticsChannelModalParams.maxHeight"></InputNumber>
                </div>
              </FormItem>
            </Col>
            <Col :span="11">
              <FormItem :label="$t('key1005391')">
                <div v-if="openType === 'look'" class="flex align-items-center">
                  <span>{{ ymsLogisticsChannelModalParams.minWeight }}</span>
                  <span> - </span>
                  <span>{{ ymsLogisticsChannelModalParams.maxWeight }}</span>
                </div>
                <div v-else class="flex align-items-center">
                  <InputNumber :min="0" :max="999999" @on-blur="blurChange" v-model="ymsLogisticsChannelModalParams.minWeight"></InputNumber>
                  <span class="ml4 mr4">{{ $t('key1000773') }}</span>
                  <InputNumber :min="0" :max="999999" @on-blur="blurChange" v-model="ymsLogisticsChannelModalParams.maxWeight"></InputNumber>
                </div>
              </FormItem>
            </Col>
            <Col :span="11">
              <FormItem :label="$t('key1005300')">
                <span v-if="openType === 'look'">{{ ymsLogisticsChannelModalParams.maxPerimeter }}</span>
                <InputNumber v-else :min="0" :max="999999" @on-blur="blurChange" v-model="ymsLogisticsChannelModalParams.maxPerimeter"></InputNumber>
              </FormItem>
            </Col>
            <Col :span="11">
              <FormItem :label="$t('key1005301')">
                <span v-if="openType === 'look'">{{ ymsLogisticsChannelModalParams.maxDimensionsLength }}</span>
                <InputNumber v-else :min="0" :max="999999" @on-blur="blurChange" v-model="ymsLogisticsChannelModalParams.maxDimensionsLength"></InputNumber>
              </FormItem>
            </Col>
            <Col :span="11">
              <FormItem :label="$t('key1005392')">
                <div v-if="openType === 'look'" class="flex align-items-center">
                  <span>{{ ymsLogisticsChannelModalParams.minVolume }}</span>
                  <span> - </span>
                  <span>{{ ymsLogisticsChannelModalParams.maxVolume }}</span>
                </div>
                <div v-else class="flex align-items-center">
                  <InputNumber :min="0" :max="999999" v-model="ymsLogisticsChannelModalParams.minVolume" @on-blur="blurChange"/>
                  <span class="font-size-12 ml4 mr4">{{ $t('key1000773') }}</span>
                  <InputNumber :min="0" :max="999999" @on-blur="blurChange" v-model="ymsLogisticsChannelModalParams.maxVolume"/>
                </div>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Card>
      <Form ref="shippingParams" :label-width="120" :disabled="looKsettings" label-position="right" @submit.native.prevent>
        <!--物流商可选设置(默认设置)-->
        <Card :bordered="true" dis-hover v-if="shippingParams.carrierParams && shippingParams.carrierParams.length > 0">
          <template #title>
            <h2 class="title_box">{{ $t('key1005308') }}</h2>
          </template>
          <div v-for="(item, cpIndex) in shippingData.carrierParams" style="display: flex; flex-wrap: wrap;">
            <template v-if="item.paramType === 'hide'">
              <FormItem v-show="false" :label="item.paramName" style="width:300px;" prop="paramValue" :key="cpIndex">
                <!-- 缓存数据，不显示 -->
                <span
                  v-if="item.paramType === 'hide'"
                  v-show="false">{{ shippingParams.carrierParams[cpIndex].paramValue }}</span>
              </FormItem>
            </template>
            <template v-else>
              <FormItem :label="item.paramName" style="width:300px;" prop="paramValue" :key="cpIndex">
                <Input
                  v-if="item.paramType === 'input'"
                  v-model.trim="shippingParams.carrierParams[cpIndex].paramValue"></Input> <Select
                v-if="item.paramType === 'select'"
                filterable
                v-model="shippingParams.carrierParams[cpIndex].paramValue"><Option
                v-for="(subItem,t) in item.carrierParamDictionaryList"
                :key="t"
                :value="subItem.itemValue">{{ subItem.itemName }} </Option></Select>
                <RadioGroup
                  v-if="item.paramType === 'radio'"
                  v-model="shippingParams.carrierParams[cpIndex].paramValue">
                  <Radio
                    v-for="(subItem,t) in item.carrierParamDictionaryList"
                    :key="t"
                    :label="subItem.itemValue">{{ subItem.itemName }}</Radio>
                </RadioGroup>
                <CheckboxGroup
                  v-if="item.paramType === 'check'"
                  v-model="shippingParams.carrierParams[cpIndex].paramValue">
                  <Checkbox
                    v-for="(subItem,t) in item.carrierParamDictionaryList"
                    :key="t"
                    :label="subItem.itemValue"></Checkbox>
                </CheckboxGroup>
              </FormItem>
            </template>
          </div>
        </Card>
        <!--派送范围及运费-->
        <Card :bordered="true" dis-hover>
          <template #title>
            <h2 class="title_box">{{ $t('key1005309') }}</h2>
          </template>
          <div class="p10">
            <p class="font-weight-bold font-size-14 mb10">{{ $t('key1005310') }}</p>
            <span v-if="openType === 'look'">{{ arriveableTypeText }}</span>
            <RadioGroup v-model="arriveableType" v-else>
              <Radio v-for="(item,index) in sendUsageTypeList" :key="index" :label="item.value" class="mr20">
                <span>{{ item.name }}</span>
              </Radio>
            </RadioGroup>
          </div>
          <div class="p10">
            <div class="font-weight-bold font-size-14 flex align-items-center justify-content-between mb10">
              <span>{{ $t('key1005311') }}</span>
              <div>
                <!--<Button @click="channelCitation" class="mr5">从其他渠道引用 </Button>-->
                <Button @click="$refs.importFreightTemplate.initImportFreightTemplateData(shippingMethodId, arriveableType)" class="mr5">{{ $t('key1005313') }}</Button>
                <Button v-if="openType !== 'look' && arriveableType !== 1" @click="addPartition">{{ $t('key1005314') }}</Button>
              </div>
            </div>
            <Row type="flex" justify="start" align="middle" class="mb25">
              <Col class="mr15">
                <Row type="flex" align="top" justify="start" :gutter="5">
                  <span class="redColor">*</span>
                  <span>{{ $t('key1005315') }}</span>
                  <Col class="mr12 width_190">
                    <div style="position: relative;" v-if="openType === 'look'">
                      <span>{{ freightCurrencyText }}</span>
                      <p class="font-size-12 color-666" style="position: absolute; top: 20px; left: 0;">{{ exchangeRateText }}</p>
                    </div>
                    <div v-else style="position: relative;">
                      <Select v-model="freightCurrency" filterable>
                        <Option v-for="(item, itemIndex) in currencyList" :key="itemIndex" :value="item.value">{{ item.label }}</Option>
                      </Select>
                      <p class="font-size-12 color-666 mt4 width_250" style="position: absolute; top: 30px; left: 0;">{{ exchangeRateText }}</p>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col class="mr30">
                <Row type="flex" justify="start" :gutter="5" align="middle">
                  <Col>
                    <span v-if="openType === 'look'">
                      {{ getEnumName(enumData, 'YmsLogisServicePriceModelFreightDiscountTypeCoreEnum', freightDiscountType) }}
                    </span>
                    <Select v-model="freightDiscountType" v-else>
                      <Option v-for="item in freightDiscountTypeList" :value="item.value">{{ item.name }}</Option>
                    </Select>
                  </Col>
                  <Col>
                    <span v-if="openType === 'look'">{{ freightDiscount.toFixed(2) }}</span>
                    <InputNumber v-else :precision="4" :min="0" v-model="freightDiscount" :max="1"/>
                  </Col>
                </Row>
              </Col>
              <Col class="mr15">
                <Row type="flex" justify="start" :gutter="5" align="middle">
                  <span>{{ $t('key1001233') }}</span>
                  <Col>
                    <span v-if="openType === 'look'">{{ weightUnit }}</span>
                    <Select v-model="weightUnit" v-else class="width_80">
                      <Option v-for="(item, itemIndex) in weightUnitList" :key="itemIndex" :value="item.value">{{ item.name }}</Option>
                    </Select>
                  </Col>
                </Row>
              </Col>
              <Col v-if="openType !== 'look'">
                <div class="redColor styleDescription">{{ $t('key1005316') }}</div>
              </Col>
            </Row>
            <Table
              :highlight-row="false"
              border
              :columns="columns4"
              class="normalTop"
              :data="data4"
              max-height="300">
            </Table>
          </div>
          <!--物流单作废费-->
          <div class="p10">
            <h2 class="font-weight-bold font-size-15 color-333">{{ $t('key1003954') }}</h2>
            <p class="flex align-items-center  mb8 mt8">
              <span class="color-666">{{ $t('key1005317') }}</span>
              <span class="redColor">{{ $t('key1005318') }}</span>
            </p>
            <div class="flex align-items-center">
              <span>{{ $t('key1005319') }}</span>
              <RadioGroup v-model="isCollectCancel">
                <Radio :label="0" class="mr30">{{ $t('key1005320') }}</Radio>
                <Radio :label="1">{{ $t('key1005321') }}</Radio>
              </RadioGroup>
              <template v-if="isCollectCancel === 1">
                <span class="ml100">{{ $t('key1005322') }}</span>
                <RadioGroup v-model="collectCancelType" @on-change="feeCollectionMethodTypeChange">
                  <Radio :label="2" class="mr30">{{ $t('key1005323') }}</Radio>
                  <Radio :label="1">{{ $t('key1005324') }}</Radio>
                </RadioGroup>
              </template>
            </div>
            <div class="flex align-items-center mb12 mt10" v-if="isCollectCancel === 1">
              <span class="redColor mr3">*</span>
              <span>{{ $t('key1005325') }}</span>
              <span v-if="openType === 'look'">{{ currencySystemText }}</span>
              <Select v-model="currencySystem" filterable v-else style="width:200px;" @on-change="currencySystemChange">
                <Option v-for="(item, itemIndex) in currencyList" :key="itemIndex" :value="item.value">{{ item.label }}</Option>
              </Select>
            </div>
            <Form class="flex flex-direction" :disabled="looKsettings" v-if="isCollectCancel === 1">
              <Form-item>
                <div class="flex align-items-center mb24" style="position: relative;" v-for="(item,idx) in feeCollectionConfigList">
                  <span class="mr8">{{ $t('key1005326') }}</span>
                  <Form-item :class="(item.startErrorText || item.errorText) && !item.disabled ? 'ivu-form-item-error errorTextBox' : ''">
                    <InputNumber
                      :disabled="item.disabled"
                      style="width: 100px"
                      :min="0"
                      :max="9999999"
                      :formatter="(value) => formatterNumber(value, 2)"
                      @on-blur="verificationInterval(item, idx, 'left')"
                      v-model.trim="item.minHour">
                    </InputNumber>
                    <span v-if="item.startErrorText && !item.disabled" class="font-size-12 redColor errorTxt">{{ item.startErrorText }}</span>
                  </Form-item>
                  <span class="ml8 mr8">-</span>
                  <Input :disabled="true" style="width: 100px;" v-if="idx === feeCollectionConfigList.length - 1" v-model.trim="infinite"></Input>
                  <Form-item v-else :class="item.endErrorText || item.errorText ? 'ivu-form-item-error errorTextBox' : ''">
                    <InputNumber
                      style="width: 100px"
                      :min="0"
                      :max="9999999"
                      :formatter="(value) => formatterNumber(value, 2)"
                      @on-blur="blurEndInput(item, idx)"
                      v-model.trim="item.maxHour">
                    </InputNumber>
                    <span v-if="item.endErrorText" class="font-size-12 redColor errorTxt">{{ item.endErrorText }}</span>
                  </Form-item>
                  <span class="display-inline-block width_165 mr20 ml8" :style="idx === feeCollectionConfigList.length - 1 ? {visibility: 'hidden'} : {}">
                  {{ $t('key1005287') + (item.maxHour ? Number(item.maxHour.toFixed(2)) : ' ') + 'h）' }}
                </span>
                  <template v-if="collectCancelType === 2">
                    <Form-item :class="item.priceText ? 'ivu-form-item-error errorTextBox' : ''">
                      <div class="flex align-items-center">
                        <span class="mr8">{{ $t('key1005327') }}</span>
                        <InputNumber
                          style="width: 150px"
                          :min="0"
                          :max="9999999"
                          :formatter="(value) => formatterNumber(value, 2)"
                          @on-blur="verificationInterval(item, idx, 'price')"
                          v-model.trim="item.invalidFees">
                        </InputNumber>
                      </div>
                      <span v-if="item.priceText" :style="collectCancelType === 2 ? {left: '178px'} : {left: '193px'}"
                        class="font-size-12 redColor errorPriceTxt">{{ item.priceText }}</span>
                    </Form-item>
                    <span class="ml8">{{ '(' + item.currency + ')' }}</span>
                  </template>
                  <template v-else>
                    <Form-item :class="item.priceText ? 'ivu-form-item-error errorTextBox' : ''">
                      <div class="flex align-items-center">
                        <span class="mr8">{{ $t('key1005328') }}</span>
                        <InputNumber
                          style="width: 150px"
                          :min="0"
                          :max="9999999"
                          :formatter="(value) => formatterNumber(value, 2)"
                          @on-blur="verificationInterval(item, idx, 'price')"
                          v-model.trim="item.logisticsFee">
                        </InputNumber>
                      </div>
                      <span v-if="item.priceText" :style="collectCancelType === 2 ? {left: '178px'} : {left: '193px'}"
                        class="font-size-12 redColor errorPriceTxt">{{ item.priceText }}</span>
                    </Form-item>
                    <span class="ml8 mr4">%</span>
                    <span>{{ $t('key1005329') }}</span>
                  </template>
                  <template v-if="!looKsettings">
                    <Icon type="ios-trash" size="22" color="#EB422F" v-if="idx !==feeCollectionConfigList.length -1"
                      class="ml10 cursor" @click="deleteFeeCollectionConfigBtn(idx)"/>
                    <Icon type="md-add-circle" size="21" color="#2D8CF0" v-else
                      class="ml10 cursor" @click="addAFeeCollectionConfigBtn(idx)"/>
                  </template>
                  <span v-if="item.errorText && !isValueEmpty(item.minHour) && !isValueEmpty(item.maxHour)" class="font-size-12 redColor errorStyles">
                    {{ item.errorText }}
                  </span>
                </div>
              </Form-item>
            </Form>
          </div>
        </Card>
        <!-- 速卖通线上发货 -->
        <!--        <Card :bordered="true" dis-hover v-if="showStatus === 'API_AE_LG' || showStatus === 'API_EDIS' || showStatus === 'api_joomLogistics'">
                  <template #title>
                    <h2 class="title_box" v-if="showStatus === 'API_AE_LG'">速卖通线上发货设置</h2>
                    <h2 class="title_box" v-if="showStatus === 'API_EDIS'">eDIS物流设置</h2>
                    <h2 class="title_box" v-if="showStatus === 'api_joomLogistics'">Joom Logistics设置</h2>
                  </template>
                  <Row :gutter="16">
                    &lt;!&ndash; 发货地址 &ndash;&gt;
                    <Col span="8" v-if="showStatus !== 'api_joomLogistics'">
                      <div style="font-size:12px;marginTop:10px;marginLeft:20%;">
                        <span v-if="showStatus !== 'API_EDIS'">选择发件地址：</span>
                        <span v-if="showStatus === 'API_EDIS'">发货地址：</span> <Select
                        style="width:100px"
                        v-model="sendAddress.addressValue"
                        @on-change="changeSender"
                        filterable><Option
                        v-for="(item, index) in sendList"
                        :key="index"
                        :value="item.addressId">{{ item.cityName + ' ' + item.provinceName + ' ' + item.countryName + ' ' + item.name }} </Option>
                      </Select>
                      </div>
                      <div style="marginTop:10px;marginLeft:10px;">
                        <Form ref="tabs" :label-width="75" label-position="left" @submit.native.prevent>
                          <Row>
                            <Col span="24">
                              <FormItem :label-width="80" label="姓名：">
                                <Input v-model.trim="showSendList.name" disabled></Input>
                              </FormItem>
                            </Col>
                          </Row>
                          <Row :gutter="16">
                            <Col span="12">
                              <FormItem :label-width="80" label="国家/地区：">
                                <Input v-model.trim="showSendList.countryName" disabled></Input>
                              </FormItem>
                            </Col>
                            <Col span="12">
                              <FormItem :label-width="60" label="省州：">
                                <Input v-model.trim="showSendList.provinceName" disabled></Input>
                              </FormItem>
                            </Col>
                          </Row>
                          <Row :gutter="16">
                            <Col span="12">
                              <FormItem :label-width="80" label="城市：">
                                <Input v-model.trim="showSendList.cityName" disabled></Input>
                              </FormItem>
                            </Col>
                            <Col span="12">
                              <FormItem :label-width="60" label="区县：">
                                <Input v-model.trim="showSendList.districtName" disabled></Input>
                              </FormItem>
                            </Col>
                          </Row>
                          <Row>
                            <Col span="24">
                              <FormItem :label-width="80" label="街道：">
                                <Input v-model.trim="showSendList.street1" disabled></Input>
                              </FormItem>
                            </Col>
                          </Row>
                          <Row>
                            <Col span="24">
                              <FormItem :label-width="80" label="邮箱：">
                                <Input v-model.trim="showSendList.email" disabled></Input>
                              </FormItem>
                            </Col>
                          </Row>
                          <Row :gutter="16">
                            <Col span="12">
                              <FormItem :label-width="80" label="邮编：">
                                <Input v-model.trim="showSendList.postcode" disabled></Input>
                              </FormItem>
                            </Col>
                            <Col span="12">
                              <FormItem :label-width="60" label="旺旺：">
                                <Input v-model.trim="showSendList.trademanageId" disabled></Input>
                              </FormItem>
                            </Col>
                          </Row>
                          <Row :gutter="16">
                            <Col span="12">
                              <FormItem :label-width="80" label="手机：">
                                <Input v-model.trim="showSendList.mobile" disabled></Input>
                              </FormItem>
                            </Col>
                          </Row>
                        </Form>
                      </div>
                    </Col>
                    &lt;!&ndash; 揽收地址 &ndash;&gt;
                    <Col span="8">
                      <div style="font-size:12px;marginTop:10px;marginLeft:20%;">
                        <span v-if="showStatus !== 'API_EDIS'">选择揽收地址：</span>
                        <span v-if="showStatus === 'API_EDIS'">交运地址：</span> <Select
                        style="width:100px"
                        v-model="pickupAddress.addressValue"
                        @on-change="changePickup"
                        filterable><Option
                        v-for="(item, index) in pickupList"
                        :key="index"
                        :value="item.addressId">{{ item.cityName + ' ' + item.provinceName + ' ' + item.countryName + ' ' + item.name }} </Option>
                      </Select>
                      </div>
                      <div style="marginTop:10px;marginLeft:10px;">
                        <Form ref="pickupTabs" :label-width="75" label-position="left" @submit.native.prevent>
                          <Row>
                            <Col span="24">
                              <FormItem :label-width="80" label="姓名：">
                                <Input v-model.trim="showPickupList.name" disabled></Input>
                              </FormItem>
                            </Col>
                          </Row>
                          <Row :gutter="16">
                            <Col span="12">
                              <FormItem :label-width="80" label="国家/地区：">
                                <Input v-model.trim="showPickupList.countryName" disabled></Input>
                              </FormItem>
                            </Col>
                            <Col span="12">
                              <FormItem :label-width="60" label="省州：">
                                <Input v-model.trim="showPickupList.provinceName" disabled></Input>
                              </FormItem>
                            </Col>
                          </Row>
                          <Row :gutter="16">
                            <Col span="12">
                              <FormItem :label-width="80" label="城市：">
                                <Input v-model.trim="showPickupList.cityName" disabled></Input>
                              </FormItem>
                            </Col>
                            <Col span="12">
                              <FormItem :label-width="60" label="区县：">
                                <Input v-model.trim="showPickupList.districtName" disabled></Input>
                              </FormItem>
                            </Col>
                          </Row>
                          <Row>
                            <Col span="24">
                              <FormItem :label-width="80" label="街道：">
                                <Input v-model.trim="showPickupList.street1" disabled></Input>
                              </FormItem>
                            </Col>
                          </Row>
                          <Row>
                            <Col span="24">
                              <FormItem :label-width="80" label="邮箱：">
                                <Input v-model.trim="showPickupList.email" disabled></Input>
                              </FormItem>
                            </Col>
                          </Row>
                          <Row :gutter="16">
                            <Col span="12">
                              <FormItem :label-width="80" label="邮编：">
                                <Input v-model.trim="showPickupList.postcode" disabled></Input>
                              </FormItem>
                            </Col>
                            <Col span="12">
                              <FormItem :label-width="60" label="旺旺：">
                                <Input v-model.trim="showPickupList.trademanageId" disabled></Input>
                              </FormItem>
                            </Col>
                          </Row>
                          <Row :gutter="16">
                            <Col span="12">
                              <FormItem :label-width="80" label="手机：">
                                <Input v-model.trim="showPickupList.mobile" disabled></Input>
                              </FormItem>
                            </Col>
                          </Row>
                        </Form>
                      </div>
                    </Col>
                    &lt;!&ndash; 退件地址 &ndash;&gt;
                    <Col span="8" v-if="showStatus !== 'api_joomLogistics' && showStatus !== 'API_EDIS'">
                      <div style="font-size:12px;marginTop:10px;marginLeft:20%;">
                        选择退件地址： <Select
                        style="width:100px"
                        v-model="refundAddress.addressValue"
                        @on-change="changeRefund"
                        filterable><Option
                        v-for="(item, index) in refundList"
                        :key="index"
                        :value="item.addressId">{{ item.cityName + ' ' + item.provinceName + ' ' + item.countryName + ' ' + item.name }} </Option>
                      </Select>
                      </div>
                      <div style="marginTop:10px;marginLeft:10px;">
                        <Form ref="tabs" :label-width="75" label-position="left" @submit.native.prevent>
                          <Row>
                            <Col span="24">
                              <FormItem :label-width="80" label="姓名：">
                                <Input v-model.trim="showRefundList.name" disabled></Input>
                              </FormItem>
                            </Col>
                          </Row>
                          <Row :gutter="16">
                            <Col span="12">
                              <FormItem :label-width="80" label="国家/地区：">
                                <Input v-model.trim="showRefundList.countryName" disabled></Input>
                              </FormItem>
                            </Col>
                            <Col span="12">
                              <FormItem :label-width="60" label="省州：">
                                <Input v-model.trim="showRefundList.provinceName" disabled></Input>
                              </FormItem>
                            </Col>
                          </Row>
                          <Row :gutter="16">
                            <Col span="12">
                              <FormItem :label-width="80" label="城市：">
                                <Input v-model.trim="showRefundList.cityName" disabled></Input>
                              </FormItem>
                            </Col>
                            <Col span="12">
                              <FormItem :label-width="60" label="区县：">
                                <Input v-model.trim="showRefundList.districtName" disabled></Input>
                              </FormItem>
                            </Col>
                          </Row>
                          <Row>
                            <Col span="24">
                              <FormItem :label-width="80" label="街道：">
                                <Input v-model.trim="showRefundList.street1" disabled></Input>
                              </FormItem>
                            </Col>
                          </Row>
                          <Row>
                            <Col span="24">
                              <FormItem :label-width="80" label="邮箱：">
                                <Input v-model.trim="showRefundList.email" disabled></Input>
                              </FormItem>
                            </Col>
                          </Row>
                          <Row :gutter="16">
                            <Col span="12">
                              <FormItem :label-width="80" label="邮编：">
                                <Input v-model.trim="showRefundList.postcode" disabled></Input>
                              </FormItem>
                            </Col>
                            <Col span="12">
                              <FormItem :label-width="60" label="旺旺：">
                                <Input v-model.trim="showRefundList.trademanageId" disabled></Input>
                              </FormItem>
                            </Col>
                          </Row>
                          <Row :gutter="16">
                            <Col span="12">
                              <FormItem :label-width="80" label="手机：">
                                <Input v-model.trim="showRefundList.mobile" disabled></Input>
                              </FormItem>
                            </Col>
                          </Row>
                        </Form>
                      </div>
                    </Col>
                    &lt;!&ndash; 交运方式与揽件时间 &ndash;&gt;
                    <Col span="8" v-if="showStatus === 'API_EDIS'">
                      <div style="font-size:12px;marginTop:10px;marginLeft:20%;">交运方式与揽件时间</div>
                      <div style="marginTop:10px;marginLeft:10px;">
                        <Form ref="tabs" :label-width="75" label-position="left" @submit.native.prevent>
                          <Row>
                            <Col span="24">
                              <FormItem :label-width="80" label="交运方式：">
                                <RadioGroup v-model="deliverType">
                                  <Radio label="PICK_UP" disabled>上门揽收
                                  </Radio>
                                  <Radio label="DROP_OFF" disabled>卖家自送
                                  </Radio>
                                </RadioGroup>
                              </FormItem>
                            </Col>
                          </Row>
                        </Form>
                        <Form ref="tabs" :label-width="75" label-position="left" @submit.native.prevent>
                          <Row>
                            <Col span="24">
                              <FormItem :label-width="80" label="揽件时间：">
                                <RadioGroup v-model="deliverTime">
                                  <Radio label="TIME_14_16" disabled>14:00-16:00</Radio>
                                  <Radio label="TIME_16_18" disabled>16:00-18:00</Radio>
                                </RadioGroup>
                              </FormItem>
                            </Col>
                          </Row>
                        </Form>
                      </div>
                    </Col>
                    &lt;!&ndash;代理人&ndash;&gt;
                    <Col span="8" v-if="showStatus === 'API_EDIS'">
                      <FormItem label="代理人">
                        <Select v-model="agentAddress.addressValue" style="width: 200px;" @on-change="changeAgentAddress" filterable>
                          <Option v-for="item in agentList" :value="item.carrierPlatformAccountAddressId">{{ item.name }}</Option>
                        </Select>
                      </FormItem>
                    </Col>
                  </Row>
                </Card>-->
        <!--清关费用配置-->
        <!--        <Card :bordered="true" dis-hover>
          <template #title>
            <h2 class="title_box">清关费用配置</h2>
          </template>
          <div class="flex align-items-center mb12">
            <span>是否收取清关费用：</span>
            <RadioGroup v-model="iossStatus">
              <Radio :label="1">收取</Radio>
              <Radio :label="0">不收取</Radio>
            </RadioGroup>
          </div>
          <div class="flex align-items-center mb12" v-if="iossStatus === 1">
            <span>比例配置：申报价值在 0 至150EUR时，按如下税率计算后</span>
            <Input v-model="floatRate" type="number" placeholder="请输入浮动比例" style="width: 250px; margin: 0 10px;">
              <span slot="append">%</span>
              <Select v-model="floatType" slot="prepend" style="width: 70px">
                <Option :value="1">上浮</Option>
                <Option :value="2">下浮</Option>
              </Select>
            </Input>
            <span>超出150欧的包裹将下发物流失败。</span>
          </div>
          <div v-if="iossStatus === 1" class="mt20 mb15">
            <div class="flex align-items-center">
              <div class="flex align-items-center" v-for="ele in iossRateTitleList">
                <span class="p5 p10 serial_title_box title_bold">{{ ele.serial_title }}</span>
                <span class="p5 p10 cnName_title_box title_bold">{{ ele.cnName_title }}</span>
                <span class="p5 p10 rateVal_title_box title_bold">{{ ele.rateVal_title }}</span>
              </div>
            </div>
            <div class="flex align-items-center flex-wrap">
              <div v-for="(item, index) in iossRateList">
                <span class="p5 p10 serial_box">{{ index + 1 }}</span>
                <span class="p5 p10 cnName_box">{{ item.cnName }}</span>
                <span class="p5 p10 rateVal_box">{{ item.rateVal }}</span>
              </div>
            </div>
          </div>
        </Card>-->
      </Form>
      <template #footer>
        <Button @click="ymsLogisticsChannelModal = false">{{ $t('key1000248') }}</Button>
        <Button v-if="openType !=='look'" @click="setShippingMethod" :loading="buttonTalg" type="primary">{{ $t('key1000555') }}</Button>
      </template>
    </Modal>
    <!-- 编辑/查看运费 -->
    <billingModelEditingModal
      ref="billingModelEditing"
      @saveBtn="editOK"
      :looKsettings="looKsettings"
      :weightUnit="weightUnit"
      billingModelType="YMS"
      :freightCurrency="freightCurrency">
    </billingModelEditingModal>
    <!--批量导入 计费模型-->
    <importFreightTemplateModal
      ref="importFreightTemplate"
      sourceType="selfOwnedLogistics"
      :uploadZoneExcel="uploadZoneExcel"
      @updateImportFreightTemplateData="importFreightTemplateSuccess">
    </importFreightTemplateModal>
    <!--从其他渠道引用-弹窗-->
    <channelReferenceModal ref="channelReference" @saveChannel="saveChannel"></channelReferenceModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from '@/components/mixin/common_mixin';
import publicService from '@/components/mixin/publicService_mixin';
import importFreightTemplateModal from "@/components/common/importFreightTemplateModal";
import channelReferenceModal from "@/components/common/channelReferenceModal";
import billingModelEditingModal from "@/components/common/billingModelEditingModal";
import {
  amountHandel, convertCurrency, isJSON, getConverter, isValueEmpty,
  formatterNumber, toNumber, toPercent, getWeightUnitData, getCurrencyData, getRegionalRcountriesData,
  getEnabledPlatforms, getAllCountrysData, getDataSetBatchList, getEnumName, getEnumList, processFreightText, mergeByCountriesStrict
} from "@/utils/common";
import {publicExceptionCodes} from "@/config/exceptionCode";

export default {
  name: 'ownLogisticsChannelsModal',
  mixins: [Mixin, publicService],
  props: {
    type: { // 01 API对接  02 第三方物流
      type: String,
      default: '01'
    },
    activeCarrierName: {
      type: String,
      default: ''
    },
    showShippingSettingId: {
      type: String,
      default: null
    },
    platformGroup: {
      type: Array,
      default: () => []
    },
    formInline: {
      type: Object,
      default: () => {
      }
    },
    showStatus: {
      type: String,
      default: null
    },
    merchantType: {
      type: String,
      default: '2'
    }
  },
  data() {
    let self = this;
    return {
      looKsettings: false,
      openType: 'add',
      uploadZoneExcel: api.post_carrierShippingMethodPriceModelZone_importExcel,
      buttonTalg: false,
      ymsLogisticsChannelModal: false,
      shippingMethodId: null,
      data4: [],
      data5: [
        {
          'carrierShippingMethodPriceModelZoneId': null,
          'carrierShippingMethodSectionChargesList': [
            {
              'additionalFeeRate': 0,
              'carrierShippingMethodPriceModelZoneId': null,
              'carrierShippingMethodSectionChargesId': null,
              'endWeight': 0,
              'firstWeight': 0,
              'firstWeightPrice': 0,
              'operatingCost': 0,
              'price': 0,
              'priceCurrency': 'CNY',
              'priceType': 0,
              'registrationFee': 0,
              'sortNo': 0,
              'startWeight': 0,
              'unitWeight': 0,
              'unitWeightPrice': 0
            }
          ],
          'countryTwoCodeList': [],
          'priceType': 0,
          'volumeWeight': 0,
          'weightType': 0,
          'zoneName': '0',
          carrierShippingMethodPriceModelZoneCountryList: []
        }
      ], // 全球可达（运费相同）
      data6: [
        {
          'carrierShippingMethodPriceModelZoneId': null,
          'carrierShippingMethodSectionChargesList': [
            {
              'additionalFeeRate': 0,
              'carrierShippingMethodPriceModelZoneId': null,
              'carrierShippingMethodSectionChargesId': null,
              'endWeight': 0,
              'firstWeight': 0,
              'firstWeightPrice': 0,
              'operatingCost': 0,
              'price': 0,
              'priceCurrency': 'CNY',
              'priceType': 0,
              'registrationFee': 0,
              'sortNo': 0,
              'startWeight': 0,
              'unitWeight': 0,
              'unitWeightPrice': 0
            }
          ],
          'countryTwoCodeList': [],
          'priceType': 0,
          'volumeWeight': 0,
          'weightType': 0,
          'zoneName': '0',
          carrierShippingMethodPriceModelZoneCountryList: []
        }
      ], // 全球可达（运费不同）
      data7: [], // 非全球可达
      // 计费模型币种
      freightCurrency: 'CNY',
      freightDiscount: 1,
      freightDiscountType: '1',
      columns4: [
        {
          key: 'zoneName',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005239'),
          align: 'center',
          width: 100,
          render(h, params) {
            if (params.row.zoneName === '0') {
              return h('div', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005240'));
            } else {
              return h('div', params.row.zoneName);
            }
          }
        },
        {
          key: 'carrierShippingMethodPriceModelZoneCountryList',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005241'),
          align: 'center',
          minWidth: 150,
          render(h, params) {
            let list = params.row.carrierShippingMethodPriceModelZoneCountryList || [];
            if (params.row.zoneName === '0') {
              return h('div', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005242'));
            } else {
              return h('div', {class: 'flex justify-content-center align-items-center flex-wrap'}, self.setCnNameFun(h, list));
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005243'),
          align: 'center',
          width: 110,
          render(h, params) {
            let priceType = params.row.priceType;
            let text = getEnumName(self.enumData, 'YmsLogisServicePriceModelZonePriceTypeCoreEnum', priceType, 'number');
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005244'),
          align: 'center',
          width: 110,
          render(h, params) {
            let weightType = params.row.weightType;
            let text = getEnumName(self.enumData, 'YmsLogisServicePriceModelZoneWeightTypeCoreEnum', weightType, 'number');
            return h('span', text);
          }
        },
        {
          key: 'formula',
          align: 'center',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005245'),
          minWidth: 210,
          render: (h, params) => {
            return h('span', {
              domProps: {
                innerHTML: params.row.formula || ''
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'center',
          key: 'opts',
          width: 120,
          render(h, params) {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000003'),
                    show: self.openType !== 'look',
                    clickFn: () => {
                      self.copyBillingModelBtn(params.row)
                    }
                  },
                  {
                    text: self.openType === 'look' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: true,
                    clickFn: () => {
                      self.editIndex = params.index;
                      self.$refs['billingModelEditing'].initBillingModelData(params.row, 'supplier');
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    show: params.row.zoneName !== '0' && self.openType !== 'look',
                    clickFn: () => {
                      self.data4.splice(params.index, 1);
                      // 全球可达（运费不同）
                      if (self.arriveableType === 2) {
                        self.data6.splice(params.index, 1);
                      }
                      // 非全球可达
                      else if (self.arriveableType === 3) {
                        self.data7.splice(params.index, 1);
                      }
                      self.data4.forEach((i, index) => {
                        if (self.arriveableType === 3) {
                          i.zoneName = index + 1 + '';
                        } else {
                          i.zoneName = index + '';
                        }
                      });
                      self.handleIossRateSettingData();
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    self.optionBtnWidth.push(value);
                    params.column.width = Math.max(...self.optionBtnWidth) > 120 ? Math.max(...self.optionBtnWidth) : 120;
                    self.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      checkAll: false,
      warehouseIdList: [],
      indeterminate: false,
      showMarkShipping: false,
      markDeliveryType: [
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005246'), value: 0},
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005247'), value: 1},
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005248'), value: 2},
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005249'), value: 3}
      ],
      carrierCodeArr: null,
      sendAddress: {
        addressType: 'sender',
        addressValue: null
      },
      pickupAddress: {
        addressType: 'pickup',
        addressValue: null
      },
      refundAddress: {
        addressType: 'refund',
        addressValue: null
      },
      agentAddress: {
        addressType: 'agent',
        name: null,
        street1: null,
        mobile: null,
        addressValue: null
      },
      sendList: [], // 下拉数据
      agentList: [], // 下拉数据
      showSendList: [], // 下拉选中后的展示数据
      pickupList: [],
      showPickupList: [],
      showRefundList: [],
      showAgentList: [],
      refundList: [],
      deliverType: 'PICK_UP',
      deliverTime: 'TIME_16_16',
      arriveableType: 1,
      iossStatus: 0, // 是否收取清关费用 0否 1是
      floatType: 1, // 上浮
      floatRate: 0, // 浮动比率
      ymsLogisticsChannelModalParams: {
        logisticsChannelsName: '',
        minEfficiency: 0,
        maxEfficiency: 0,
        maxLength: 0,
        maxWidth: 0,
        maxHeight: 0,
        minWeight: 0,
        maxWeight: 0,
        maxPerimeter: 0,
        maxDimensionsLength: 0,
        minVolume: 0,
        maxVolume: 0,
        logisType: '',
        isPrintPickingList: 0,
      },
      shippingParams: { // 平台标发货设置
        shippingMethodId: '',
        carrierParams: [],
        shippingData: null,
        platformCarrierSettings: null
      },
      shippingData: {
        carrierParams: []
      },
      pricingParams: {
        priceType: null,
        weightType: null,
        subCostWay: null
      },
      pricingModelCommonColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005239'),
          key: 'name',
          minWidth: 100,
          align: 'center'
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005241'),
          key: 'reachState',
          minWidth: 150,
          maxWidth: 240,
          align: 'center',
          render: (h, params) => {
            return h('div', self.getPricingReachStateData(params.row.carrierShippingMethodPriceModelZoneCountryList));
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000697'),
          key: 'costPrice',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('InputNumber', {
                props: {
                  value: params.row.price,
                  min: 0,
                  max: 9999999,
                  placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005231')}`
                }
              }), h('div', {
                class: 'flexBox normalTop flexBoxJustContent'
              }, [
                h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005250') + '：'), h('span', {
                  class: 'redColor'
                }, '$ ' + params.row.price * (self.freightDiscount === null ? 100 : self.freightDiscount) / 100)
              ])
            ]);
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001023'),
          key: 'registrationFee',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('InputNumber', {
              props: {
                value: params.row.registrationFee,
                min: 0,
                max: 9999999,
                placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001023')}`
              }
            });
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001024'),
          key: 'operatingCost',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('InputNumber', {
              props: {
                value: params.row.operatingCost,
                min: 0,
                max: 9999999,
                placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001024')}`
              }
            });
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001027'),
          key: 'additionalFeeRate',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('InputNumber', {
              props: {
                value: params.row.additionalFeeRate,
                min: 0,
                max: 9999999,
                placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001027')}`
              }
            });
          }
        }
      ],
      pricingModelContinuedHeavyColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005233'),
          key: 'firstWeight',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('InputNumber', {
              props: {
                value: params.row.firstWeight,
                min: 0,
                max: 9999999,
                placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005233')}`
              },
              on: {
                'input': (val) => {
                  self.cachePricingData[params.index].firstWeight = val;
                }
              }
            });
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001017'),
          key: 'firstWeightPrice',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('InputNumber', {
                props: {
                  value: params.row.firstWeightPrice,
                  min: 0,
                  max: 9999999,
                  placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001017')}`
                },
                on: {
                  'input': (val) => {
                    self.cachePricingData[params.index].firstWeightPrice = val;
                  }
                }
              }), h('div', {
                class: 'flexBox normalTop flexBoxJustContent'
              }, [
                h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005250') + '：'), h('span', {
                  class: 'redColor'
                }, '$ ' + params.row.firstWeightPrice * (self.freightDiscount === null
                  ? 100
                  : self.freightDiscount) / 100)
              ])
            ]);
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005234'),
          key: 'unitWeight',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('InputNumber', {
              props: {
                value: params.row.unitWeight,
                min: 0,
                max: 9999999,
                placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005234')}`
              },
              on: {
                'input': (val) => {
                  self.cachePricingData[params.index].unitWeight = val;
                }
              }
            });
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001021'),
          key: 'unitWeightPrice',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('InputNumber', {
                props: {
                  value: params.row.unitWeightPrice,
                  min: 0,
                  max: 9999999,
                  placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001021')}`
                },
                on: {
                  'input': (val) => {
                    self.cachePricingData[params.index].unitWeightPrice = val;
                  }
                }
              }), h('div', {
                class: 'flexBox normalTop flexBoxJustContent'
              }, [
                h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005250') + '：'), h('span', {
                  class: 'redColor'
                }, '$ ' + params.row.unitWeightPrice * (self.freightDiscount === null
                  ? 100
                  : self.freightDiscount) / 100)
              ])
            ]);
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001027'),
          key: 'additionalFeeRate',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('InputNumber', {
              props: {
                value: params.row.additionalFeeRate,
                min: 0,
                max: 9999999,
                placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001027')}`
              }
            });
          }
        }
      ],
      pricingModelColumns: [],
      cachePriceModelColumns: [],
      carrierShippingMethodParmas: {
        maxPrice: null,
        minPrice: 0,
        maxLength: 0,
        minLength: 0,
        maxShippingFeeIncome: null,
        minShippingFeeIncome: 0,
        minEfficiency: 0,
        maxEfficiency: 0,
        minGoodsQuantity: 0,
        maxGoodsQuantity: null
      },
      modalData: {},
      selectType: null,
      logisticsChannelTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005220'),
      iossRateSettingData: [],
      iossRateList: [],
      iossRateTitleList: [],
      countrysOriginalData: [],
      weightUnit: 'g',
      weightUnitList: [],
      converterData: {},
      carrierShippingMethodPriceModelId: null,

      infinite: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000836'),
      isCollectCancel: 0, // 是否收取此费用
      collectCancelType: 2, // 费用收取方式
      currencySystem: 'CNY', // 计费币种
      feeCollectionConfigList: [
        {
          minHour: null,
          maxHour: null,
          invalidFees: null,
          logisticsFee: null,
          currency: 'CNY',
          startErrorText: '',
          endErrorText: '',
          priceText: '',
          errorText: '',
          disabled: false,
        }
      ],
      currencyList: [],
      enumData: []
    };
  },
  computed: {
    labelWidth() {
      let width = this.languagesVal === 'zh-CN' ? 120 : 160;
      return width;
    },
    freightCurrencyText() {
      let text = '';
      let list = this.currencyList.filter((item) => {
        if (item.value === this.freightCurrency) {
          return item
        }
      });
      if (list.length > 0) {
        text = list[0].label
      }
      return text;
    },
    // 汇率
    exchangeRateText() {
      let value = convertCurrency(1, this.freightCurrency, this.converterData);
      return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007106') + value + ' ' + this.freightCurrency;
    },
    currencySystemText() {
      let text = '';
      if (this.currencyList.length > 0) {
        this.currencyList.map((item) => {
          if (item.value === this.currencySystem) {
            text = item.label
          }
        });
      }
      return text;
    },
    arriveableTypeText() {
      return getEnumName(this.enumData, 'YmsLogisServiceArriveableTypeCoreEnum', this.arriveableType, 'number')
    },
    freightDiscountTypeList() {
      const ENUM_KEY = 'YmsLogisServicePriceModelFreightDiscountTypeCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY)
    },
    // 派送范围
    sendUsageTypeList() {
      const ENUM_KEY = 'YmsLogisServiceArriveableTypeCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number')
    }
  },
  methods: {
    formatterNumber,
    isValueEmpty,
    getEnumName,
    // 初始化数据
    async initSupplierLogisticsChannelData(openType, shippingMethodId, merchantId) {
      let v = this;
      v.shippingMethodId = shippingMethodId;
      v.optionBtnWidth = [];
      v.openType = openType;
      let enumKeyList = [
        'YmsLogisServicePriceModelZoneWeightTypeCoreEnum',
        'YmsLogisServicePriceModelZonePriceTypeCoreEnum',
        'YmsLogisServicePriceModelFreightDiscountTypeCoreEnum',
        'YmsLogisServiceArriveableTypeCoreEnum'
      ];
      v.countrysOriginalData = await getAllCountrysData();
      v.currencyList = await getCurrencyData();
      v.enumData = await getDataSetBatchList(enumKeyList);
      /* v.getIossRateSettingData();*/
      if (v.openType !== 'look') {
        getWeightUnitData().then((data) => {
          v.weightUnitList = data;
        });
      }
      let objTitle = {
        look: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005257'),
        edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007107'),
      }
      v.looKsettings = openType === 'look';
      v.logisticsChannelTitle = objTitle[openType];
      if (['look', 'edit'].includes(openType)) {
        v.showShippingSetting(shippingMethodId, merchantId);
      } else {
        v.ymsLogisticsChannelModal = true;
      }
      v.$forceUpdate();
    },
    // 获取物流渠道详情数据
    showShippingSetting(shippingMethodId, merchantId) {
      let v = this;
      v.optionBtnWidth = [];
      // 获取从其他渠道引用的物流商数据
      if (v.system === 'yms') {
        v.GetQuotingLogisticsData();
      }
      let url = v.system === 'supplier'
        ? api.get_ymsSupplierCarrierShippingMethod + shippingMethodId
        : api.get_ymsSupplierCarrierShippingMethod_api_supplierShippingMethod + `?carrierShippingMethodId=${shippingMethodId}&supplierMerchantId=${merchantId}`;
      v.axios.get(url, {loading: true}).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            let {carrierShippingMethod, carrierShippingMethodPriceModel} = data;
            v.iossStatus = data.iossStatus;
            let value = (data.floatRate * 100) || 0;
            v.floatRate = data.floatRate ? amountHandel(value) : 0;
            v.floatType = data.floatType || 1;
            if (carrierShippingMethodPriceModel) {
              v.freightCurrency = carrierShippingMethodPriceModel.freightCurrency;
              v.freightDiscount = carrierShippingMethodPriceModel.freightDiscount;
              v.freightDiscountType = carrierShippingMethodPriceModel.freightDiscountType;
              v.weightUnit = carrierShippingMethodPriceModel.weightUnit || 'g';
              v.carrierShippingMethodPriceModelId = carrierShippingMethodPriceModel.carrierShippingMethodPriceModelId;
            }
            let carrierShippingMethodPriceModelZoneList = data.carrierShippingMethodPriceModelZoneList || [];
            if (carrierShippingMethodPriceModelZoneList.length > 0) {
              carrierShippingMethodPriceModelZoneList.forEach(i => {
                let list = i.carrierShippingMethodPriceModelZoneCountryList || [];
                if (list.length > 0) {
                  list.map((ele) => {
                    if (ele.carrierShippingMethodPriceModelZoneCountryPC && Object.keys(ele.carrierShippingMethodPriceModelZoneCountryPC).length > 0) {
                      ele.interceptFirstNumber = ele.carrierShippingMethodPriceModelZoneCountryPC.interceptFirstNumber;
                      ele.postalCodeList = ele.carrierShippingMethodPriceModelZoneCountryPC.postalCodeList;
                    }
                  })
                  i.countryTwoCodeList = list.map(j => {
                    return j.twoCode;
                  });
                }
              });
              v.$nextTick(() => {
                v.arriveableType = carrierShippingMethod.arriveableType;
                v.data4 = carrierShippingMethodPriceModelZoneList;
                if (v.arriveableType === 1) {
                  v.data5 = carrierShippingMethodPriceModelZoneList;
                } else if (v.arriveableType === 2) {
                  v.data6 = carrierShippingMethodPriceModelZoneList; // 计费模型
                } else if (v.arriveableType === 3) {
                  v.data7 = carrierShippingMethodPriceModelZoneList; // 计费模型
                }
              });
            } else {
              v.arriveableType = 1;
              v.data4 = v.data5; // data5 为默认值
            }
            let carrierShippingMethodName = '';
            if (carrierShippingMethod) {
              if (isJSON(carrierShippingMethod.carrierShippingMethodName)) {
                let name = JSON.parse(carrierShippingMethod.carrierShippingMethodName);
                carrierShippingMethodName = name['zh-CN'];
              } else {
                carrierShippingMethodName = carrierShippingMethod.carrierShippingMethodName;
              }
              data.logisticsChannelsName = carrierShippingMethodName;
            }
            v.ymsLogisticsChannelModalParams = {...data, carrierShippingMethodName, ...carrierShippingMethod};
            // 物流费配置
            v.isCollectCancel = carrierShippingMethod?.isCollectCancel || 0;
            v.collectCancelType = carrierShippingMethod?.collectCancelType || 2
            let carrierShippingMethodCanceledPrices = data.carrierShippingMethodCanceledPrices || [];
            if (carrierShippingMethodCanceledPrices.length > 0) {
              v.feeCollectionConfigList = [];
              v.currencySystem = carrierShippingMethodCanceledPrices[0].priceCurrency;
              carrierShippingMethodCanceledPrices.map((item, index) => {
                v.feeCollectionConfigList.push({
                  minHour: item.startTime,
                  maxHour: carrierShippingMethodCanceledPrices.length - 1 === index ? null : item.endTime,
                  invalidFees: v.collectCancelType === 2 ? isValueEmpty(item.price) ? null : item.price : null,
                  logisticsFee: v.collectCancelType === 1 ? isValueEmpty(item.price) ? null : Number(toPercent(item.price, 2, false)) : null,
                  currency: item.priceCurrency,
                  startErrorText: '',
                  endErrorText: '',
                  priceText: '',
                  errorText: '',
                  disabled: index !== 0,
                })
              });
            }
          }
          getConverter().then((list) => {
            v.converterData = list;
          });
          v.ymsLogisticsChannelModal = true;
        }
      });
    },
    // 税率配置的数据
    getIossRateSettingData() {
      let v = this;
      v.axios.get(api.get_ymsIossRateSetting_query).then(response => {
        if (response.data.code === 0) {
          v.iossRateSettingData = response.data.datas || [];
          if (v.iossRateSettingData.length > 0) {
            let length = v.iossRateSettingData.length;
            let list = [
              {serial_title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000343'), cnName_title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002474'), rateVal_title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005385')},
              {serial_title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000343'), cnName_title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002474'), rateVal_title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005385')},
              {serial_title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000343'), cnName_title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002474'), rateVal_title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005385')}
            ];
            if (length <= 3) {
              v.iossRateTitleList = list.slice(0, length);
            } else {
              v.iossRateTitleList = list;
            }
          }
          v.handleIossRateSettingData();
        }
      });
    },
    // 处理税率的数据
    handleIossRateSettingData() {
      let v = this;
      v.iossRateList = [];
      // 全球可达
      if ([1, 2].includes(v.arriveableType)) {
        v.iossRateList = JSON.parse(JSON.stringify(v.iossRateSettingData));
      }
      // 非全球可达
      else {
        let twoCodeList = [];
        let countryList = [];
        if (v.data4.length > 0) {
          v.data4.map((item) => {
            let carrierShippingMethodPriceModelZoneCountryList = item.carrierShippingMethodPriceModelZoneCountryList || [];
            if (carrierShippingMethodPriceModelZoneCountryList.length > 0) {
              carrierShippingMethodPriceModelZoneCountryList.map((ele) => {
                twoCodeList.push(ele.twoCode);
              })
            }
          })
        }
        twoCodeList = v.uniqueFunc(twoCodeList);
        if (v.iossRateSettingData.length > 0) {
          v.iossRateSettingData.map((item) => {
            if (twoCodeList.includes(item.twoCode)) {
              countryList.push(item);
            }
          })
        }
        countryList = v.uniqueFunc(countryList, 'twoCode');
        v.iossRateList = JSON.parse(JSON.stringify(countryList));
      }
      v.iossRateList.map((item) => {
        item.rateVal = (item.rate * 100).toFixed(2) + '%';
        v.countrysOriginalData.map((ele) => {
          if (item.countryCode === ele.twoCode) {
            item.cnName = ele.cnName;
          }
        })
      })
    },
    // 获取国家的数据
    getAllCountryName(loading) {
      let v = this;
      getRegionalRcountriesData(loading).then((data) => {
        v.$refs['billingModelEditing'].countryCodesName = data;
      });
    },
    // 设置/编辑/新增自定义物流渠道弹窗---显示状态发生变化时触发的事件
    ymsLogisticsChannelModalChange(open) {
      if (!open) {
        this.carrierShippingMethodPriceModelId = null;
        this.data5 = [
          {
            'carrierShippingMethodPriceModelZoneId': null,
            'carrierShippingMethodSectionChargesList': [
              {
                'additionalFeeRate': 0,
                'carrierShippingMethodPriceModelZoneId': null,
                'carrierShippingMethodSectionChargesId': null,
                'endWeight': 0,
                'firstWeight': 0,
                'firstWeightPrice': 0,
                'operatingCost': 0,
                'price': 0,
                'priceCurrency': 'CNY',
                'priceType': 0,
                'registrationFee': 0,
                'sortNo': 0,
                'startWeight': 0,
                'unitWeight': 0,
                'unitWeightPrice': 0
              }
            ],
            'countryTwoCodeList': [],
            'priceType': 0,
            'volumeWeight': 0,
            'weightType': 0,
            'zoneName': '0',
            carrierShippingMethodPriceModelZoneCountryList: []
          }
        ];
        this.data6 = [
          {
            'carrierShippingMethodPriceModelZoneId': null,
            'carrierShippingMethodSectionChargesList': [
              {
                'additionalFeeRate': 0,
                'carrierShippingMethodPriceModelZoneId': null,
                'carrierShippingMethodSectionChargesId': null,
                'endWeight': 0,
                'firstWeight': 0,
                'firstWeightPrice': 0,
                'operatingCost': 0,
                'price': 0,
                'priceCurrency': 'CNY',
                'priceType': 0,
                'registrationFee': 0,
                'sortNo': 0,
                'startWeight': 0,
                'unitWeight': 0,
                'unitWeightPrice': 0
              }
            ],
            'countryTwoCodeList': [],
            'priceType': 0,
            'volumeWeight': 0,
            'weightType': 0,
            'zoneName': '0',
            carrierShippingMethodPriceModelZoneCountryList: []
          }
        ];
        this.data7 = [];
        this.arriveableType = 1;
        this.agentAddress.addressValue = '';
        this.infinite = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000836');
        this.isCollectCancel = 0;
        this.collectCancelType = 2;
        this.currencySystem = 'CNY';
        this.feeCollectionConfigList = [
          {
            minHour: null,
            maxHour: null,
            invalidFees: null,
            logisticsFee: null,
            currency: 'CNY',
            startErrorText: '',
            endErrorText: '',
            priceText: '',
            errorText: '',
            disabled: false,
          }
        ];
        this.resetData();
      } else {
        this.getAllCountryName(false);
      }
    },

    // 从其他渠道引用
    channelCitation() {
      this.$refs.channelReference.channelModal = true;
      let selectProvider = this.modalData.carrier.carrierId
      this.$refs.channelReference.selectProvider = selectProvider;
      this.$refs.channelReference.logisticsChannel = this.modalData.carrierShippingMethod.shippingMethodId;
      this.$refs.channelReference.ChangeSelectProvider(selectProvider);
    },

    // 新增分区
    addPartition() {
      if (this.arriveableType === 2) {
        let lenght = this.data6.length + '';
        if (this.data4.length > 0) {
          this.data6 = JSON.parse(JSON.stringify(this.data4));
        }
        this.data6.push({
          'carrierShippingMethodPriceModelZoneId': null,
          'carrierShippingMethodSectionChargesList': [
            {
              'additionalFeeRate': 0,
              'carrierShippingMethodPriceModelZoneId': null,
              'carrierShippingMethodSectionChargesId': null,
              'endWeight': 0,
              'firstWeight': 0,
              'firstWeightPrice': 0,
              'operatingCost': 0,
              'price': 0,
              'priceCurrency': 'CNY',
              'priceType': 0,
              'registrationFee': 0,
              'sortNo': 0,
              'startWeight': 0,
              'unitWeight': 0,
              'unitWeightPrice': 0
            }
          ],
          'countryTwoCodeList': [],
          'priceType': 0,
          'volumeWeight': 0,
          'weightType': 0,
          'zoneName': lenght,
          carrierShippingMethodPriceModelZoneCountryList: []
        });
        this.data4 = JSON.parse(JSON.stringify(this.data6));
      } else if (this.arriveableType === 3) {
        let lenght = this.data7.length + 1 + '';
        if (this.data4.length > 0) {
          this.data7 = JSON.parse(JSON.stringify(this.data4));
        }
        this.data7.push({
          'carrierShippingMethodPriceModelZoneId': null,
          'carrierShippingMethodSectionChargesList': [
            {
              'additionalFeeRate': 0,
              'carrierShippingMethodPriceModelZoneId': null,
              'carrierShippingMethodSectionChargesId': null,
              'endWeight': 0,
              'firstWeight': 0,
              'firstWeightPrice': 0,
              'operatingCost': 0,
              'price': 0,
              'priceCurrency': 'CNY',
              'priceType': 0,
              'registrationFee': 0,
              'sortNo': 0,
              'startWeight': 0,
              'unitWeight': 0,
              'unitWeightPrice': 0
            }
          ],
          'countryTwoCodeList': [],
          'priceType': 0,
          'volumeWeight': 0,
          'weightType': 0,
          'zoneName': lenght,
          carrierShippingMethodPriceModelZoneCountryList: []
        });
        this.data4 = JSON.parse(JSON.stringify(this.data7));
      }
    },

    // 添加特例国家
    addSpecialCountry(platformId) {
      let v = this;
      let obj = {
        carrierCode: '',
        countryCode: '',
        platformId: platformId,
        trackingNumberType: 0,
        markDeliveryType: 0
      };
      if (platformId === 'wish') {
        obj.deliveryCountryCode = '';
      }
      v.shippingParams.platformCarrierSettings[platformId].push(obj);
    },

    // 删除--单个平台标发货设置
    delShippingParamsItem(index, platformId) {
      let v = this;
      v.shippingParams.platformCarrierSettings[platformId].splice(index, 1);
    },

    // 判断是否有选中---平台标发货设置
    getNewShippingParamsObj(obj) {
      let arr = [];
      let v = this;
      return new Promise(resolve => {
        let len = Object.keys(obj.platformCarrierSettings).length;
        for (let item in obj.platformCarrierSettings) {
          len--;
          obj.platformCarrierSettings[item].forEach((n, i) => {
            v.platformGroup.forEach((m, t) => { // 如果勾选了
              if (n.platformId === m.platformId && m.checkboxStatus) {
                arr.push(n);
              }
            });
          });
          if (len === 0) {
            resolve(arr);
          }
        }
        if (len === 0) {
          resolve();
        }
      });
    },

    // 设置/编辑自定义物流渠道--保存按钮
    setShippingMethod() {
      const v = this;
      const params = v.ymsLogisticsChannelModalParams;
      const {
        carrierShippingMethod, minEfficiency, maxEfficiency, maxLength, maxWidth, maxHeight,
        minWeight, maxWeight, maxPerimeter, maxDimensionsLength, minVolume, maxVolume, logisticsChannelsName,
      } = params;
      /*
      if (!params.code) {
        v.$Message.error('物流渠道代码不能为空');
        return;
      }
      if (v.iossStatus === 1) {
        const reg = v.$regular.twoDecimalPlaces;
        if (!reg.test(v.floatRate)) {
          v.$Message.warning('税率必须是大于等于0且最多允许2位小数');
          return false;
        }
      }
      */

      if (!v.handleSubmit('shippingParams')) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005388'));
        return false;
      }

      // 判断计费模型默认分区国家
      const hasInvalidZone = v.data4.some(item => item.zoneName !== '0' && item.carrierShippingMethodPriceModelZoneCountryList.length === 0);
      if (hasInvalidZone) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005387'));
        return false;
      }
      // 校验物流费配置
      let feeCollectionConfigTalg = true;
      let carrierShippingMethodCanceledPricList = [];
      if (v.isCollectCancel === 1) {
        let keyList = ['left', 'right', 'price'];
        v.feeCollectionConfigList.map((item, index) => {
          keyList.map((key) => {
            v.verificationInterval(item, index, key);
          });
          let price = v.collectCancelType === 2 ? Number(amountHandel(item.invalidFees)) : toNumber(item.logisticsFee, 4);
          carrierShippingMethodCanceledPricList.push({
            endTime: item.maxHour ? item.maxHour : index === v.feeCollectionConfigList.length - 1 ? 9999999 : null,
            price: price,
            startTime: item.minHour,
            priceCurrency: item.currency,
          })
        });
        feeCollectionConfigTalg = v.feeCollectionConfigList.every((ele) => {
          return !ele.startErrorText && !ele.endErrorText && !ele.priceText && !ele.errorText
        });
        if (!feeCollectionConfigTalg) {
          v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005263'));
          return false;
        }
      } else {
        carrierShippingMethodCanceledPricList = [];
      }
      let name = {
        'zh-CN': logisticsChannelsName,
      }
      const query = {
        shippingMethodId: carrierShippingMethod.shippingMethodId,
        carrierShippingMethodPriceModel: {
          freightCurrency: v.freightCurrency,
          freightDiscount: v.freightDiscount,
          freightDiscountType: v.freightDiscountType,
          weightUnit: v.weightUnit,
          carrierShippingMethodPriceModelId: v.carrierShippingMethodPriceModelId
        },
        carrierShippingMethodPriceModelZoneList: v.data4,
        updateApplicationScopeBo: {
          goodsTagList: [],
          skuList: [],
          warehouseIdList: [],
        },
        arriveableType: v.arriveableType,
        baseDetail: {
          carrierShippingMethodCode: carrierShippingMethod.carrierShippingMethodCode,
          isInsurance: carrierShippingMethod.isInsurance,
          arriveableType: v.arriveableType,
          shippingMethodId: carrierShippingMethod.shippingMethodId,
          carrierId: carrierShippingMethod.carrierId,
          languageCarrierShippingMethodName: JSON.stringify(name),
          carrierShippingMethodName: JSON.stringify(name),
          logisticsInterface: carrierShippingMethod.logisticsInterface,
          status: carrierShippingMethod.status,
          minEfficiency,
          maxEfficiency,
          maxLength,
          maxWidth,
          maxHeight,
          minWeight,
          maxWeight,
          maxPerimeter,
          maxDimensionsLength,
          minVolume,
          maxVolume,
        },
        isCollectCancel: v.isCollectCancel,
        collectCancelType: v.isCollectCancel === 0 ? 2 : v.collectCancelType,
        carrierShippingMethodCanceledPriceBos: carrierShippingMethodCanceledPricList,
      };

      v.$refs['ymsLogisticsChannelModalParams'].validate((valid) => {
        if (!valid) return;
        v.buttonTalg = true;
        v.axios.put(api.put_ymsSupplierCarrierShippingMethod_update, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
          v.buttonTalg = false;
          if (res.data.code === 0) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
            v.ymsLogisticsChannelModal = false;
            v.$emit('updateData', true);
          }
        });
      });
    },

    // 选中--全部自营仓库
    handleCheckAll() {
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }
      this.indeterminate = false;
      if (this.checkAll) {
        this.warehouseIdList = [];
        this.storeList.map(i => {
          if (i.warehouseType === '0') {
            this.warehouseIdList.push(i.warehouseId);
          }
        });
      } else {
        this.warehouseIdList = [];
      }
    },

    // 选中--平台标发货设置
    setCheckboxStatus(value, index) {
      let v = this;
      delete v.platformGroup[index].checkboxStatus;
      v.$set(v.platformGroup[index], 'checkboxStatus', value);
      v.showMarkShipping = false;
      v.$nextTick(function () {
        v.showMarkShipping = true;
      });
    },

    // 表单必填项的校验规则
    validCarrier(index, platformId, status, val) {
      let v = this;
      return function (rule, value, callback) {
        if (status && (v.shippingParams.platformCarrierSettings[platformId][0].carrierCode === '' ||
          v.shippingParams.platformCarrierSettings[platformId][0].carrierCode === null)) {
          callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005389')));
        } else {
          callback();
        }
      };
    },

    // 选择发货地址
    changeSender(val) {
      let v = this;
      v.sendList.forEach((n, i) => {
        if (n.addressId === val) {
          v.showSendList = n;
        }
      });
    },
    changeAgentAddress(value) {
      this.agentList.forEach((n, i) => {
        if (n.carrierPlatformAccountAddressId === value) {
          this.agentAddress.name = n.name;
          this.agentAddress.street1 = n.street1;
          this.agentAddress.mobile = n.mobile;
        }
      });
    },
    // 选择揽收地址
    changePickup(val) {
      let v = this;
      v.pickupList.forEach((n, i) => {
        if (n.addressId === val) {
          v.showPickupList = n;
          v.deliverType = n.type;
          v.deliverTime = n.pickupTime;
        }
      });
    },

    // 选择退件地址
    changeRefund(val) {
      let v = this;
      v.refundList.forEach((n, i) => {
        if (n.addressId === val) {
          v.showRefundList = n;
        }
      });
    },

    // 计费模型编辑弹窗--保存按钮
    editOK(obj) {
      let v = this;
      if (obj) {
        v.data4[v.editIndex].carrierShippingMethodSectionChargesList = obj.cacheEditPriceModalData;
        v.data4[v.editIndex].volumeWeight = obj.pricingQuantityMode.volumeWeight;
        v.data4[v.editIndex].weightType = obj.pricingQuantityMode.weightType;
        v.data4[v.editIndex].priceType = obj.pricingQuantityMode.priceType;
        v.data4[v.editIndex].formula = obj.freightText;
        v.data4[v.editIndex].countryTwoCodeList = obj.choseCountryId;
        v.data4[v.editIndex].carrierShippingMethodPriceModelZoneCountryList = obj.countryData.filter(i => {
          if (obj.choseCountryId.indexOf(i.twoCode) > -1 && obj.isShowCountry) {
            i.carrierShippingMethodPriceModelZoneCountryPC = {
              interceptFirstNumber: i.interceptFirstNumber,
              postalCodeList: i.postalCodeList
            }
            return i;
          }
        });
        let data = JSON.parse(JSON.stringify(v.data4));
        v.data4 = [];
        v.data4 = data;
        v.handleIossRateSettingData();
      }
    },

    // 导入运费模板批量上传文件成功
    importFreightTemplateSuccess(res) {
      const v = this;
      if (res.data.code !== 0) {
        const text = publicExceptionCodes(res.data.code);
        const errorMsg = text || aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005265');
        v.$Message.error(errorMsg);
        return false;
      }
      v.$refs['importFreightTemplate'].importFreightTemplateModal = false;
      v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000251'));
      v.data4 = [];
      // 2 覆盖原有数据, 1 国家相同覆盖不同追加
      const coveredType = res.coveredType;
      let data = res.data.datas.carrierShippingMethodPriceModelZones || [];
      data.forEach(i => {
        let zoneCountryList = i.carrierShippingMethodPriceModelZoneCountryList || [];
        const countryMap = new Map((v.countrysOriginalData || []).map(country => [country.twoCode, country]));
        if (zoneCountryList.length > 0) {
          zoneCountryList.map((ele) => {
            if (ele.carrierShippingMethodPriceModelZoneCountryPC && Object.keys(ele.carrierShippingMethodPriceModelZoneCountryPC).length > 0) {
              ele.interceptFirstNumber = ele.carrierShippingMethodPriceModelZoneCountryPC.interceptFirstNumber;
              ele.postalCodeList = ele.carrierShippingMethodPriceModelZoneCountryPC.postalCodeList;
            }
            Object.assign(ele, {
              cnName: countryMap.get(ele.twoCode)?.name || '',
              countryId: countryMap.get(ele.twoCode)?.countryId || '',
              enName: countryMap.get(ele.twoCode)?.enName || ''
            });
          });
          i.countryTwoCodeList = zoneCountryList.map(j => {
            return j.twoCode;
          });
        }
        // 计费公式
        i.formula = processFreightText(i.priceType, false, true);
      });
      // 根据 coveredType 是否覆盖数据
      const handleData = (oldData) => coveredType === 2 ? data : mergeByCountriesStrict(oldData, data);
      // zoneName（默认区保留0，其余递增）
      const resetZoneName = (list = [], keepZero = false) => {
        let index = keepZero ? 1 : 0;
        return list.map(item => {
          if (keepZero && item.zoneName === '0') return item;
          return {...item, zoneName: String(index++)};
        });
      };

      switch (v.arriveableType) {
        // 1 全球可达运费相同
        case 1:
          let newData = data.flatMap(item => item.carrierShippingMethodSectionChargesList || []);
          v.data5.map((item) => {
            item.carrierShippingMethodSectionChargesList = newData;
            item.priceType = data[0]?.priceType;
            item.formula = data[0]?.formula;
            item.volumeWeight = data[0]?.volumeWeight;
            item.weightType = data[0]?.weightType;
          });
          v.data4 = [...v.data5];
          break;
        // 2 全球可达运费不同
        case 2:
          const base = v.data6.filter(i => i.zoneName === '0');
          const other = v.data6.filter(i => i.zoneName !== '0');
          let arr2 = coveredType === 2 ? [...base, ...data] : [...base, ...mergeByCountriesStrict(other, data)];
          const nonDefault = arr2.filter(i => i.zoneName !== '0');
          v.data6 = [...base, ...resetZoneName(nonDefault, true)];
          v.data4 = [...v.data6];
          break;
        // 3 非全球可达
        case 3:
          let arr3 = handleData(v.data7);
          v.data7 = resetZoneName(arr3, true);
          v.data4 = [...v.data7];
          break;
      }
      v.$refs['importFreightTemplate'].importFreightTemplateModal = false;
    },

    // 设置表格列
    setTableColumns(type) {
      let v = this;
      if (type === 1) {
        v.pricingModelColumns = v.pricingModelCommonColumns;
      } else if (type === 2) {
        v.getNewArr(v.pricingModelCommonColumns).then(arr => {
          arr.splice(2, 1, ...v.pricingModelContinuedHeavyColumns);
          v.pricingModelColumns = arr;
        });
      } else {
        v.getNewArr(v.pricingModelCommonColumns).then(arr => {
          arr.splice(2, 1, ...v.cachePriceModelColumns);
          v.pricingModelColumns = arr;
        });
      }
    },

    // 浅拷贝数组
    getNewArr(arr) {
      let newArr = [];
      return new Promise(resolve => {
        for (let i = 0; i < arr.length; i++) {
          let item = arr[i];
          newArr.push(item);
          if (i === arr.length - 1) {
            resolve(newArr);
          }
        }
      });
    },

    // 获取物流服务商
    makeCarrierCode() {
      let v = this;
      return new Promise(resolve => {
        v.carrierCodeArr = Object.create(null);
        v.shippingParams.platformCarrierSettings = Object.create(null);
        if (v.platformGroup !== null && v.platformGroup.length > 0) {
          let arr = [];
          for (let k = 0; k < v.platformGroup.length; k++) {
            let platformItem = v.platformGroup[k];
            platformItem.checkboxStatus = false;
            v.carrierCodeArr[platformItem.platformId] = [];
            let obj = {
              parameterCode: platformItem.platformId,
              parameterName: 'carrierCode'
            };
            let apiUrl = api.get_orderCommonParameter.replace(/^\./, '/setting-service');
            v.axios.post(apiUrl, JSON.stringify(obj)).then(response => {
              if (response.data.code === 0) {
                v.$set(v.carrierCodeArr, platformItem.platformId, response.data.datas);
                let platObj = {
                  carrierCode: '',
                  trackingNumberType: 0,
                  platformId: platformItem.platformId,
                  markDeliveryType: 0
                };
                v.$set(v.shippingParams.platformCarrierSettings, platformItem.platformId, [platObj]);
                arr.push(1);
                if (arr.length === v.platformGroup.length) { // 这里出问题
                  resolve(true);
                }
              }
            });
          }
        } else {
          resolve(true);
        }
      });
    },

    // 获取设置/编辑/新增自定义物流渠道弹窗的表单参数
    handleSubmit(name) {
      let v = this;
      let result = true;
      v.$refs[name].validate(function (valid) {
        result = !!valid;
      });
      return result;
    },

    // 重置弹窗表单数据
    resetData() {
      let v = this;
      v.buttonTalg = false;
      v.arriveableType = 1;
      v.checkboxLimit = '0';
      v.carrierCodeArr = null;
      v.limitWeighStatus = false;
      v.distribution = 0;
      v.distributionStatus = false;
      v.shippingParams = {
        shippingMethodId: '',
        shippingData: {
          carrierParams: []
        },
        carrierParams: [],
        platformCarrierSettings: null
      };
      v.shippingMethodSpinLoading = true;
      // v.makeCarrierCode();
      // v.makePlatformGroup();
      v.showMarkShipping = false;
      // 清空发货设置展示数据
      v.sendAddress.addressValue = null;
      v.pickupAddress.addressValue = null;
      v.refundAddress.addressValue = null;
      v.showSendList = [];
      v.showPickupList = [];
      v.showRefundList = [];
      // 基础信息
      v.$refs['ymsLogisticsChannelModalParams'].resetFields();
      v.ymsLogisticsChannelModalParams = {
        logisticsChannelsName: '',
        minEfficiency: 0,
        maxEfficiency: 0,
        maxLength: 0,
        maxWidth: 0,
        maxHeight: 0,
        minWeight: 0,
        maxWeight: 0,
        maxPerimeter: 0,
        maxDimensionsLength: 0,
        minVolume: 0,
        maxVolume: 0,
        logisType: 1,
        arriveableType: '1',
        isPrintPickingList: 0
      };
      v.iossRateSettingData = [];
      v.iossRateList = [];
      v.carrierShippingMethodPriceModelId = null;
    },

    // 获取所有平台的数据
    makePlatformGroup() {
      let v = this;
      let platformGroup = v.$store.state.platformGroup;
      if (platformGroup === null) {
        getEnabledPlatforms().then(result => {
          if (result) {
            v.$emit('changPlatformGroup', v.$store.state.platformGroup);
          }
        });
      } else {
        v.$emit('changPlatformGroup', platformGroup);
      }
    },

    // 设置店铺的数据
    setShopGroup(shopList, openList) { // 加载适用平台帐号列表
      let v = this;
      let obj = {};
      let arrObj = {
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110'),
        expand: true,
        children: []
      };
      let platformGroup = v.$store.state.platformGroup;
      if (platformGroup && platformGroup.length > 0) {
        function makePlatformGroup() { // 读可用平台列表
          return new Promise(resolve => {
            for (let i = 0; i < platformGroup.length; i++) {
              if (!obj.hasOwnProperty(platformGroup[i].platformId)) {
                arrObj.children.push({
                  title: platformGroup[i].platformId,
                  saleAccountId: null,
                  expand: true,
                  children: []
                });
                obj[platformGroup[i].platformId] = arrObj.children.length - 1;
              }
              if (i === platformGroup.length - 1) {
                resolve(true);
              }
            }
          });
        }

        function makeRangeShopList() { // 适用平台帐号
          return new Promise(resolve => {
            for (let t = 0; t < shopList.length; t++) {
              let item = shopList[t];
              arrObj.children[obj[item.platformId]].children = [];
              if (obj.hasOwnProperty(item.platformId) && openList && openList.length > 0) {
                for (let i = 0; i < openList.length; i++) {
                  let sItem = openList[i];
                  let subItem = {
                    title: item.account,
                    saleAccountId: item.saleAccountId,
                    checked: (sItem.saleAccountId === item.saleAccountId && sItem.platformId === item.platformId) || (sItem.saleAccountId === null && sItem.platformId === item.platformId) || false,
                    platformId: item.platformId,
                    expand: false,
                    children: []
                  };
                  if (sItem.saleAccountId === null) {
                    arrObj.children.forEach((p, g) => {
                      if (p.title === sItem.platformId) {
                        p.checked = true;
                      }
                    });
                  }
                  if (sItem.platformId === item.platformId) {
                    arrObj.children[obj[item.platformId]].children.push(subItem);
                  }

                  if (t === shopList.length - 1) resolve(true);
                }
              } else if (obj.hasOwnProperty(item.platformId) && openList && openList.length === 0) {
                let subItem = {
                  title: item.account,
                  saleAccountId: item.saleAccountId,
                  checked: false,
                  platformId: item.platformId,
                  expand: false,
                  children: []
                };
                arrObj.children[obj[item.platformId]].children.push(subItem);
                if (t === shopList.length - 1) resolve(true);
              } else {
                resolve(true);
              }
            }
          });
        }

        function setShopAccount() {
          v.shopAccount = [arrObj];
        }

        async function getStartMakeShop() {
          const result = await makePlatformGroup();
          if (result) {
            const mslResult = await makeRangeShopList();
            if (mslResult) {
              await setShopAccount();
            }
          }
        }

        getStartMakeShop();
      }
    },

    // 设置计费模型编辑弹窗的表格
    setCachePriceModelColumns(cData) {
      let v = this;
      v.cachePriceModelColumns = [];
      for (let i = 0; i < cData[0].carrierShippingMethodSectionChargesList.length; i++) {
        let item = cData[0].carrierShippingMethodSectionChargesList[i];
        let culumnItem = {
          align: 'center',
          minWidth: 230,
          renderHeader: (h, col) => {
            return h('div', [
              h('span', item.startWeight), h('span', {
                style: {
                  margin: '0 3px'
                }
              }, '-'), h('span', item.endWeight), h('span', {
                style: {
                  margin: '0 3px'
                }
              }, 'g')
            ]);
          },
          render: (h, params) => {
            if (item.priceType === 3) { // 编辑状态下，priceType等于3时返回结果
              return h('div', {
                style: {
                  padding: '8px 0'
                }
              }, [
                h('div', {
                  class: 'flexBox'
                }, [
                  h('span', {
                    style: {
                      color: 'red',
                      marginRight: '5px',
                      position: 'relative',
                      top: '8px'
                    }
                  }, '*'),
                  h('span', {
                    style: {
                      position: 'relative',
                      top: '6px',
                      'margin-right': '5px'
                    }
                  }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005268')),
                  h('span', {
                    style: {
                      position: 'relative',
                      top: '6px',
                      'margin-right': '5px'
                    }
                  }, v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].firstWeight),
                  h('span', {
                    style: {
                      position: 'relative',
                      top: '6px',
                      'margin': '0 5px'
                    }
                  }, 'g'),
                  h('InputNumber', {
                    props: {
                      value: v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].firstWeightPrice,
                      min: 0,
                      max: 9999999,
                      size: 'small'
                    },
                    style: {
                      width: '60px',
                      marginTop: '3px'
                    },
                    on: {
                      'input': (val) => {
                        v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].firstWeightPrice = val;
                      }
                    }
                  }),
                  h('span', {
                    style: {
                      position: 'relative',
                      top: '6px',
                      'margin-left': '5px'
                    }
                  }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005269'))
                ]), h('div', {
                  class: 'flexBox normalTop flexBoxJustContent'
                }, [
                  h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005250') + '：'), h('span', {
                    class: 'redColor'
                  }, Math.round((v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].firstWeightPrice * (v.freightDiscount === null
                    ? 100
                    : v.freightDiscount) / 100) * 100) / 100)
                ]), h('div', {
                  class: 'flexBox normalTop'
                }, [
                  h('span', {
                    style: {
                      color: 'red',
                      marginRight: '5px',
                      position: 'relative',
                      top: '8px'
                    }
                  }, '*'),
                  h('span', {
                    style: {
                      position: 'relative',
                      top: '6px',
                      'margin-right': '5px'
                    }
                  }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005270')),
                  h('span', {
                    style: {
                      position: 'relative',
                      top: '6px',
                      'margin-right': '5px'
                    }
                  }, v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].unitWeight),
                  h('span', {
                    style: {
                      position: 'relative',
                      top: '6px',
                      'margin': '0 5px'
                    }
                  }, 'g'),
                  h('InputNumber', {
                    props: {
                      value: v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].unitWeightPrice,
                      min: 0,
                      max: 9999999,
                      size: 'small'
                    },
                    style: {
                      width: '60px',
                      marginTop: '3px'
                    },
                    on: {
                      'input': (val) => {
                        v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].unitWeightPrice = val;
                      }
                    }
                  }),
                  h('span', {
                    style: {
                      position: 'relative',
                      top: '6px',
                      'margin-left': '5px'
                    }
                  }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005269'))
                ]), h('div', {
                  class: 'flexBox normalTop flexBoxJustContent'
                }, [
                  h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005250') + '：'), h('span', {
                    class: 'redColor'
                  }, Math.round((v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].unitWeightPrice * (v.freightDiscount === null
                    ? 100
                    : v.freightDiscount) / 100) * 100) / 100)
                ])
              ]);
            } else if (item.priceType === 2) { // 编辑状态下，priceType等于2时返回结果
              return h('div', [
                h('span', {
                  style: {
                    color: 'red',
                    marginRight: '5px',
                    position: 'relative',
                    top: '5px'
                  }
                }, '*'), h('InputNumber', {
                  props: {
                    value: v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].price,
                    max: 9999999,
                    min: 0
                  },
                  style: {
                    width: '80%'
                  },
                  on: {
                    'input': (val) => {
                      v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].price = val;
                    }
                  }
                }), h('div', {
                  class: 'flexBox normalTop flexBoxJustContent'
                }, [
                  h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005250') + '：'), h('span', {
                    class: 'redColor'
                  }, Math.round((v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].price * (v.freightDiscount === null
                    ? 100
                    : v.freightDiscount) / 100) * 100) / 100)
                ])
              ]);
            } else if (item.priceType === 1) { // 编辑状态下，priceType等于1时返回结果
              return h('div', {
                class: 'flexBox'
              }, [
                h('span', {
                  style: {
                    color: 'red',
                    marginRight: '5px',
                    position: 'relative',
                    top: '10px'
                  }
                }, '*'), h('InputNumber', {
                  props: {
                    value: v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].price,
                    max: 9999999,
                    min: 0
                  },
                  style: {
                    width: '75%'
                  },
                  on: {
                    'input': (val) => {
                      v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].price = val;
                    }
                  }
                }), h('span', {
                  style: {
                    position: 'relative',
                    top: '6px',
                    'margin-left': '5px'
                  }
                }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005269') + '/g'), h('div', {
                  class: 'flexBox normalTop flexBoxJustContent'
                }, [
                  h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005250') + '：'), h('span', {
                    class: 'redColor'
                  }, Math.round((v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].price * (v.freightDiscount === null
                    ? 100
                    : v.freightDiscount) / 100) * 100) / 100)
                ])
              ]);
            }
          }
        };
        v.cachePriceModelColumns.push(culumnItem);
      }
    },
    // 获取速卖通线上发货设置信息
    getSettingList(id) {
      let v = this;
      return new Promise(resolve => {
        let sendList = []; // 发货地址
        let pickupList = []; // 揽收地址
        let refundList = []; // 退件地址
        let agent = []; // 代理人
        v.axios.get(api.get_carrierAliexpressAddress + '?saleAccountId=' + id).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            data.forEach((m, t) => {
              if (m.addressType === 'sender') { // 发货
                sendList.push(m);
              } else if (m.addressType === 'pickup') { // 揽收
                pickupList.push(m);
              } else if (m.addressType === 'refund') { // 退件
                refundList.push(m);
              } else if (m.addressType === 'agent') { // 代理人
                agent.push(m);
              }
            });
            v.sendList = sendList;
            v.pickupList = pickupList;
            v.refundList = refundList;
            v.agentList = agent;
            resolve(true);
          }
        });
      });
    },

    // 获取从其他渠道引用的物流商数据
    GetQuotingLogisticsData() {
      this.$refs.channelReference.selectProviderList = [];
      this.axios.get(api.get_carrier_queryForEnableCarriers).then((res) => {
        if (res.data.code === 0) {
          let data = res.data.datas;
          if (data.length > 0) {
            data.map((item) => {
              this.$refs.channelReference.selectProviderList.push({
                id: item.carrierId,
                name: item.carrierName
              });
            });
          }
        }
      });
    },

    // 引用其他物流渠道的确定按钮
    saveChannel(data) {
      if (data) {
        this.arriveableType = data.arriveableType;
        let list = data.list;
        if (list && list.length > 0) {
          list.forEach(i => {
            i.carrierShippingMethodPriceModelId = this.carrierShippingMethodPriceModelId;
            if (i.carrierShippingMethodPriceModelZoneCountryList) {
              i.countryTwoCodeList = i.carrierShippingMethodPriceModelZoneCountryList.map(j => {
                return j.twoCode;
              });
            }
          });
          this.data4 = [];
          if (this.arriveableType === 1) {
            this.data5 = list;
            this.data4 = JSON.parse(JSON.stringify(this.data5));
          } else if (this.arriveableType === 2) {
            this.data6 = list;
            this.data4 = JSON.parse(JSON.stringify(this.data6));
          } else if (this.arriveableType === 3) {
            this.data7 = list;
            this.data4 = JSON.parse(JSON.stringify(this.data7));
          }
        }
      }
    },
    // 整合通达国家数据
    getPricingReachStateData(reachStateArr) {
      let arr = [];
      if (reachStateArr) { // reachStateArr 不为null
        for (let i = 0; i < reachStateArr.length; i++) {
          let item = reachStateArr[i];
          arr.push(item.cnName);
          if (i === reachStateArr.length - 1) {
            return arr.toString();
          }
        }
      }
    },
    blurChange() {
      if (this.ymsLogisticsChannelModalParams.minVolume === null) {
        this.ymsLogisticsChannelModalParams.minVolume = 0;
      }
      if (this.ymsLogisticsChannelModalParams.maxVolume === null) {
        this.ymsLogisticsChannelModalParams.maxVolume = 0;
      }
      if (this.ymsLogisticsChannelModalParams.maxDimensionsLength === null) {
        this.ymsLogisticsChannelModalParams.maxDimensionsLength = 0;
      }
      if (this.ymsLogisticsChannelModalParams.maxPerimeter === null) {
        this.ymsLogisticsChannelModalParams.maxPerimeter = 0;
      }
      if (this.ymsLogisticsChannelModalParams.maxWeight === null) {
        this.ymsLogisticsChannelModalParams.maxWeight = 0;
      }
      if (this.ymsLogisticsChannelModalParams.minWeight === null) {
        this.ymsLogisticsChannelModalParams.minWeight = 0;
      }
      if (this.ymsLogisticsChannelModalParams.maxLength === null) {
        this.ymsLogisticsChannelModalParams.maxLength = 0;
      }
      if (this.ymsLogisticsChannelModalParams.maxWidth === null) {
        this.ymsLogisticsChannelModalParams.maxWidth = 0;
      }
      if (this.ymsLogisticsChannelModalParams.maxHeight === null) {
        this.ymsLogisticsChannelModalParams.maxHeight = 0;
      }
      if (this.ymsLogisticsChannelModalParams.minEfficiency === null) {
        this.ymsLogisticsChannelModalParams.minEfficiency = 0;
      }
      if (this.ymsLogisticsChannelModalParams.maxEfficiency === null) {
        this.ymsLogisticsChannelModalParams.maxEfficiency = 0;
      }
    },
    // 处理国家邮编展示
    setCnNameFun(h, data) {
      let newList = [];
      if (data.length > 0) {
        data.map((item, index) => {
          let list = [];
          let interceptFirstNumber = item.interceptFirstNumber;
          let postalCodeList = item.postalCodeList || [];
          postalCodeList.map((key) => {
            let txt = interceptFirstNumber !== null ? key.slice(0, interceptFirstNumber) : key;
            list.push(txt)
          });
          let text = list.length > 0 ? `(${list.join(',')})` : '';
          newList.push(
            h('span', item.cnName),
            text ? h('span', {
              attrs: {
                title: text
              },
              class: 'postalCode_styles',
            }, text) : '',
            index !== data.length - 1 ? h('span', '、') : ''
          )
        })
      }
      return newList;
    },
    // 复制计费模型数据
    copyBillingModelBtn(item) {
      let v = this;
      let length = v.data4.length;
      length = String(length);
      let obj = v.deepCopy(JSON.parse(JSON.stringify(item)));
      obj.carrierShippingMethodPriceModelZoneCountryList = [];
      obj.zoneName = Number(length) + (v.arriveableType === 3 ? 1 : 0);
      v.data4.push(obj);
      v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000002'));
      v.updateTableDataDom(v.data4);
    },
    // 更新计费模型列表
    updateTableDataDom(data) {
      let v = this;
      if (data.length > 0) {
        v.$nextTick(() => {
          setTimeout(() => {
            v.data4 = [...data];
          }, 800)
        });
        v.$forceUpdate();
      }
    },
    // 选择计费币种
    currencySystemChange(value) {
      this.feeCollectionConfigList.map((item) => {
        item.currency = value;
      });
      this.$forceUpdate();
    },
    // 选择费用收取方式
    feeCollectionMethodTypeChange(value) {
      this.feeCollectionConfigList.map((item) => {
        if (value === 2) {
          item.invalidFees = null;
        }
        if (value === 1) {
          item.logisticsFee = null;
        }
        item.errorText = '';
        item.startErrorText = '';
        item.endErrorText = '';
        item.priceText = '';
      });
      this.$forceUpdate();
    },
    // 删除物流单作废费配置
    deleteFeeCollectionConfigBtn(idx) {
      this.feeCollectionConfigList.splice(idx, 1);
      if (this.feeCollectionConfigList.length <= 1) {
        this.feeCollectionConfigList.map((item) => {
          item.disabled = false;
        });
      } else {
        this.feeCollectionConfigList.map((item, index) => {
          if (index === 0) {
            item.disabled = false;
          }
        });
      }
      this.$forceUpdate();
    },
    // 添加物流单作废费配置
    addAFeeCollectionConfigBtn() {
      const prev = this.feeCollectionConfigList[this.feeCollectionConfigList.length - 1];
      this.feeCollectionConfigList.push({
        minHour: prev && prev.maxHour != null ? prev.maxHour : null,
        maxHour: null,
        invalidFees: null,
        logisticsFee: null,
        currency: this.currencySystem,
        startErrorText: '',
        endErrorText: '',
        priceText: '',
        errorText: '',
        disabled: true,
      });
    },
    // 自动处理区间值的数据
    blurEndInput(item, index) {
      let v = this;
      let lastIndex = v.feeCollectionConfigList.length - 1;
      if (index < lastIndex) {
        let value = item.maxHour;
        if (value) {
          v.$set(v.feeCollectionConfigList[index + 1], 'minHour', value);
          v.$forceUpdate();
        }
      }
      v.verificationInterval(item, index, 'right');
    },
    // 校验左右区间大小的问题
    verificationInterval(item, index, type) {
      let v = this;
      let startVal = item.minHour;
      let endVal = item.maxHour;
      let cost = v.collectCancelType === 2 ? item.invalidFees : item.logisticsFee;
      if (type === 'left') {
        if (isValueEmpty(startVal)) {
          v.$set(v.feeCollectionConfigList[index], 'errorText', '');
          v.$set(v.feeCollectionConfigList[index], 'startErrorText', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002428'));
        } else {
          v.$set(v.feeCollectionConfigList[index], 'startErrorText', '');
        }
      }
      if (type === 'right') {
        if (isValueEmpty(endVal)) {
          if (index !== this.feeCollectionConfigList.length - 1) {
            v.$set(v.feeCollectionConfigList[index], 'errorText', '');
            v.$set(this.feeCollectionConfigList[index], 'endErrorText', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002429'));
          }
        } else {
          v.$set(this.feeCollectionConfigList[index], 'endErrorText', '');
        }
      }
      if (type === 'price') {
        let text = v.collectCancelType === 2 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005272') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005273');
        if (isValueEmpty(cost)) {
          v.$set(this.feeCollectionConfigList[index], 'priceText', text);
        } else {
          v.$set(this.feeCollectionConfigList[index], 'priceText', '');
        }
      }
      if (!isValueEmpty(startVal) && !isValueEmpty(endVal)) {
        if (startVal >= endVal || endVal <= startVal) {
          v.$set(v.feeCollectionConfigList[index], 'errorText', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002431'));
        } else {
          v.$set(v.feeCollectionConfigList[index], 'errorText', '');
        }
      }
      v.$forceUpdate();
    },
  },
  watch: {
    arriveableType: {
      handler(newVal) {
        this.data4 = [];
        if (newVal === 1) {
          this.data4 = JSON.parse(JSON.stringify(this.data5));
          this.updateTableDataDom(this.data4);
        } else if (newVal === 2) {
          this.data4 = JSON.parse(JSON.stringify(this.data6));
          this.updateTableDataDom(this.data4);
        } else if (newVal === 3) {
          this.data4 = JSON.parse(JSON.stringify(this.data7));
          this.updateTableDataDom(this.data4);
        }
      },
      deep: true,
      immediate: true
    },
    'pricingParams.priceType': {
      handler(n, o) {
        if (n !== o) {
          this.setTableColumns(n);
        }
      }
    }
  },
  components: {
    importFreightTemplateModal,
    channelReferenceModal,
    billingModelEditingModal
  }
};
</script>

<style lang="less">

.logistic-modal .iv-btn {
  display: inline-block;
  height: 24px;
  padding: 0 7px;
  font-size: 14px;
  border-radius: 3px;
  margin: 0;
  transition: all .2s ease-in-out;
  cursor: pointer;
  border-left: 0;
  position: relative;
  color: #fff;
  background-color: #2d8cf0;
  border-color: #2d8cf0;
}

.logistic-modal .ivu-modal-confirm-body, .logistic-modal .ivu-modal-confirm-body {
  font-size: 14px;
}

.logi-CheckboxGroup .ivu-checkbox-wrapper {
  display: inline !important;
}

.logistic {
  .ivu-modal-mask {
    //z-index: 5400 !important;
  }

  .logistic-modal {
    //z-index: 5500 !important;

    .ivu-modal-body {
      max-height: 700px;
      overflow-y: auto;
    }

    .ivu-card {
      margin: 10px 10px 20px 10px;

      .title_box {
        color: #333;
        font-size: 17px;
        font-weight: bold;
      }
    }

    .redDot:before {
      content: '*';
      display: inline-block;
      margin-right: 4px;
      line-height: 1;
      font-family: SimSun;
      font-size: 12px;
      color: #ed4014;
    }

    .styleDescription {
      word-wrap: break-word;
      word-break: break-all;
      max-width: 320px;
      font-size: 12px;
    }

    .serial_box, .serial_title_box {
      width: 60px;
      display: inline-block;
      border-right: 1px solid #EBEBEB;
      border-left: 1px solid #EBEBEB;
      border-bottom: 1px solid #EBEBEB;
      text-align: center;
    }

    .cnName_box, .cnName_title_box {
      width: 150px;
      display: inline-block;
      border-right: 1px solid #EBEBEB;
      border-left: 1px solid #EBEBEB;
      border-bottom: 1px solid #EBEBEB;
      text-align: center;
    }

    .rateVal_box, .rateVal_title_box {
      width: 120px;
      display: inline-block;
      border-right: 1px solid #EBEBEB;
      border-left: 1px solid #EBEBEB;
      border-bottom: 1px solid #EBEBEB;
      text-align: center;
    }

    .serial_title_box, .cnName_title_box, .rateVal_title_box {
      border-top: 1px solid #EBEBEB;
    }

    .errorTextBox {
      position: relative;

      .errorTxt {
        position: absolute;
        left: 0;
        bottom: -28px;
      }

      .errorPriceTxt {
        position: absolute;
        left: 178px;
        bottom: -28px;
      }
    }

    .errorStyles {
      position: absolute;
      left: 123px;
      bottom: -30px;
    }
  }
}

.postalCode_styles {
  display: inline-block;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style>

<style lang="less" scoped>

.fr {
  float: right;
}

.modalItem {
  margin: 0 0 15px 0 !important
}

.select_country_checkbox {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
}

.normalTop {
  margin-top: 10px !important;
}

.redColor {
  color: red;
}

.mr5 {
  margin-right: 5px;
}

.styles_item /deep/ .ivu-form-item-content {
  display: flex;
}

.styles_item /deep/ .ivu-form-item-content a {
  display: inline-block;
  margin-left: 10px;
  cursor: pointer;
}
</style>
